// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraFilledSvg from "@ant-design/icons-svg/es/asn/VideoCameraFilled";
import AntdIcon from '../components/AntdIcon';

var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraFilledSvg
  }));
};

VideoCameraFilled.displayName = 'VideoCameraFilled';
export default React.forwardRef(VideoCameraFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/VideoCameraFilled.js
// module id = 2033
// module chunks = 0